var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-bridge"},[_c('i',{staticClass:"el-icon-loading loading-icon"}),_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.loadingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }